(() => {
  const ERR = (...args) => console.error('[SSO_BUTTON_ERROR]', ...args);

  if (window.__ssoButtonHandlerInit) {
    return;
  }
  window.__ssoButtonHandlerInit = true;

  const buildAuthUrl = (button) => {
    const authUrl = button.dataset.authUrl;
    const clientId = button.dataset.clientId;
    const idp = button.dataset.idp;
    const responseType = button.dataset.responseType;
    const scopes = button.dataset.scopes;
    const state = button.dataset.state;
    const redirectUri = button.dataset.redirectUri;

    if (!authUrl || !clientId || !idp || !responseType || !scopes || !redirectUri) {
      ERR('buildAuthUrl: required fields missing', {
        authUrl: !!authUrl,
        clientId: !!clientId,
        idp: !!idp,
        responseType: !!responseType,
        scopes: !!scopes,
        redirectUri: !!redirectUri,
      });
      return '';
    }

    const params = new URLSearchParams();
    params.set('client_id', clientId);
    params.set('idp', idp);
    params.set('redirect_uri', redirectUri);
    params.set('response_type', responseType);
    params.set('scope', scopes.replace(/,/g, ' '));
    if (state) params.set('state', state);

    return `${authUrl}?${params.toString()}`;
  };

  const bindButtons = () => {
    const buttons = document.querySelectorAll('[data-sso-button="true"]');

    buttons.forEach((button) => {
      if (button.dataset.ssoBound === 'true') return;

      button.dataset.ssoBound = 'true';

      button.addEventListener('click', () => {
        const url = buildAuthUrl(button);
        if (!url) {
          ERR('SSO URL is empty, aborting redirect');
          return;
        }
        window.location.href = url;
      });
    });
  };

  const requestBind = () => bindButtons();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', requestBind);
  } else {
    requestBind();
  }

  // Call sites that insert SSO buttons dynamically should dispatch this.
  document.addEventListener('sso:bindButtons', requestBind);
  // Section morphs can re-render liquid SSO buttons without a dedicated dispatch.
  // Skip cart/drawer morphs — ATC already hammers the main thread; SSO in the
  // drawer rebinds via sso:bindButtons / dialog open when needed.
  window.addEventListener('section-morphed', (event) => {
    const sectionId = event?.detail?.sectionId;
    if (sectionId && /cart|drawer|mini-?cart/i.test(String(sectionId))) return;
    requestBind();
  });

  window.bindSsoButtons = requestBind;
})();
